import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-affinity',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Affinity icon</title><path d="M9.368 1.08h3.778l.318.55h1.082L24 18.004v.001l-2.036 3.47H13.69l.84 1.445h-.365l-.84-1.446H3.057l-.526-.923h-.652L0 17.298l.002-.001 2.41-4.176 2.23-1.288 3.69-6.39-.742-1.285L9.368 1.08zm2.224 5.652L5.066 18.008h6.25l-.723-1.246 6.808.006-5.809-10.036Z"/></svg>`,
    styles: []
})
export class SimpleIconsAffinityComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#222324';
    @Input() className: string = 'simple-icons-affinity'
    constructor() {}
    ngOnInit(): void {}
}
